import { useState } from 'react';
import { monitoringWriteSession, setMonitoringWriteSession } from '../adapters/write-session';

export function MonitoringWriteSession() {
  const [value, setValue] = useState('');
  const [configured, setConfigured] = useState(() => monitoringWriteSession() !== null);
  const [message, setMessage] = useState('');
  return (
    <details className="nm-vs04-card">
      <summary>本地监测写入授权 · {configured ? '会话已设置' : '未设置会话'}</summary>
      <p>读取无需会话。配置修改与预警确认由后端逐次校验权限；刷新页面会清除会话。</p>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          try {
            setMonitoringWriteSession(value);
            setConfigured(true);
            setValue('');
            setMessage('会话已设置，具体操作是否获准以服务器结果为准。');
          } catch {
            setMessage('请输入有效的本地监测会话凭据。');
          }
        }}
      >
        <label>
          监测会话凭据
          <input
            type="password"
            autoComplete="off"
            value={value}
            onChange={(event) => setValue(event.target.value)}
          />
        </label>
        <button type="submit">设置本次会话</button>
        <button
          type="button"
          onClick={() => {
            setMonitoringWriteSession(null);
            setConfigured(false);
            setValue('');
            setMessage('写入会话已清除。');
          }}
        >
          清除会话
        </button>
      </form>
      <p role="status">{message}</p>
    </details>
  );
}
